<div class="app__discovery--collection--widget--container">
  <div class="app__itemCard-radioGroup items-start mt-5">
    <p class="app__sub-title text-[#53565B] font-semibold text-left leading-9">
      <span class="font-bold text-[#25508E]"> Items you might need </span> to set up
      <span class="font-bold text-[#25508E]" [matTooltip]="data?.form_name.length > 19 ? data.form_name : ''">
        {{ data?.form_name | truncateStrPipe : 28 }}</span
        >
      </p>
    </div>
    <div class="app__discovery--inner--section">
      @if (gatherOriginedReminders.length) {
        <div class="mt-5">
          <div class="app__solid--border w-full min-h-[173px] h-auto bg-white py-10 px-6">
            <span class="app__form--attribute--title font-semibold text-base text-[#53565b] leading-[22px]">
              {{ gatherOriginedReminders.length }} {{ gatherOriginedReminders.length | pluralize : 'Item' }} to collect
            </span>
            <div class="mt-5">
              @for (remainder of gatherOriginedReminders; track remainder; let last = $last) {
                <div [ngClass]="!last ? 'mb-4' : ''">
                  <div
                    class="app__between--justified--content app__solid--border w-full px-4 py-3"
              [ngClass]="{
                'border-[#1AA140]': remainder?.status == 'complete',
                'bg-[rgb(242,242,242)]': !remainder.is_active,
                'bg-white': remainder.is_active
              }"
                    >
                    <span
                      class="app__form--attribute--title app__centered-item font-normal text-base leading-[30px]"
                [matTooltip]="
                  (remainder?.status != 'complete' && remainder?.description.length > 30) ||
                  (remainder?.status == 'complete' && remainder?.description.length > 28)
                    ? remainder.description
                    : ''
                "
                      >
                      @if (remainder?.status == 'complete') {
                        <mat-icon class="text-green-500 mr-2">check_circle_outline</mat-icon>
                      }
                      {{ remainder?.description | truncateStrPipe : (remainder?.status == 'complete' ? 28 : 30) }}</span
                      >
                      <span class="flex gap-2">
                        <span
                          class="app__form--attribute--title app__centered-item app__solid--border border-[#C1C2C5] w-auto rounded-[5px] font-semibold text-sm text-center py-[6px] px-5 hover:cursor-pointer"
                  [ngClass]="{
                    'bg-[#F9D5DB] border-[#EB5757] text-[#EB5757]': !remainder?.is_active,
                    'bg-white border-[#c1c2c5] text-[#515765]': remainder?.is_active
                  }"
                          (click)="markReminderCompleteOrNotNeeded(remainder?.id, 'notneeded')"
                          >
                          Not Needed
                        </span>
                        <span
                          class="app__form--attribute--title app__centered-item app__solid--border border-[#C1C2C5] w-auto rounded-[5px] font-semibold text-sm text-center py-[6px] px-5 hover:cursor-pointer"
                  [ngClass]="{
                    'bg-[#EFFFF7] border-[#1AA140] text-[#1AA140]': remainder?.status == 'complete',
                    'bg-white border-[#c1c2c5] text-[#515765]': remainder?.status != 'complete'
                  }"
                          (click)="markReminderCompleteOrNotNeeded(remainder?.id, 'complete')"
                          >
                          Mark Collected
                        </span>
                      </span>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        } @else {
          <div class="ph-item app__solid--border w-full h-[173px] bg-white mt-7 py-10 px-6">
            <div class="ph-col-12 p-0 mt-1">
              <div class="ph-row">
                <div class="ph-col-4 h-[12px] rounded-[10px]" style="height: 12px"></div>
              </div>
              <div class="ph-row p-0 mt-6">
                <div class="ph-col-12 h-[50px] rounded-[10px]" style="height: 50px"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>
    <div class="flex items-start justify-end w-full h-[65px] pl-0 pr-0 max-[480px]:pt-4">
      <!-- <button class="app__centered-item bg-transparent font-bold text-xs gap-2 cursor-pointer" (click)="handleSteps('backward')">
      <span class="app__centered-item gap-2 text-[#18191C]"
        ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
        >
      </button> -->
      <div class="w-[158px]">
        <button
          class="app__btn--primary m-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0"
          type="submit"
          (click)="handleSteps('forward')"
          >
          Continue
        </button>
      </div>
    </div>
